export default "__VITE_ASSET__BzOD0UmB__"